import { createGlobalStyle } from 'styled-components';

import font from '../assets/fonts/Poppins-Regular.ttf';

const Typography = createGlobalStyle`
  @font-face {
    font-family: Poppins-Regular;
    src: url($(font));
  }
  html {
  font-family: 'Poppins-Regular', arial, sans-serif;
  color: var(--black);
  }
  body {
    font-size: 1.25rem;
  }
  p {
    margin: 0;
    padding: 1 rem;
  }
  h1 {
    font-family: 'Adamina', serif;
    font-size: 2rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 400;
    text-shadow: 2px 2px 0px rgb(0 0 0 / 20%);
    line-height: 1.6;
  }
  h2 {
    font-family: 'Adamina', serif;
    font-size: 1.75rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 400;
    text-shadow: 2px 2px 0px rgb(0 0 0 / 20%);
    line-height: 1.5;
  }
  h3 {
    font-family: 'Adamina', serif;
    font-size: 1.5rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 400;
    line-height: 1.4;

  }
  h4,h5,h6 {
    font-size: 1rem;
    font-weight: normal;
    margin: 0;
    line-height: 1.3;
  }
  a {
    color: var(--black);
  }
  .center {
    text-align: center;
  }
`;

export default Typography;
